export default theme => ({
  root: {
    padding: theme.spacing(3),
    minHeight: '100vh'
  },
  content: {
    marginTop: theme.spacing(5)
  }
});
